import React from "react";
import { DataTable, Table } from "@sscs/ui";
import { isValid } from "date-fns";
import styles from "./malwareDetails.module.scss";
const COLUMNS = [
    { id: "scanner", label: "Scanner", width: "50%" },
    { id: "detections", label: "Detections", width: "50%" },
];
const ScannerList = ({ scanners, headerText, firstScanned, }) => {
    if (!scanners || Object.keys(scanners).length === 0)
        return null;
    const sortedScanners = Object.keys(scanners).sort();
    const firstScannedDate = firstScanned
        ? new Date(firstScanned)
        : new Date("invalid");
    return (React.createElement(DataTable, { columns: COLUMNS, title: headerText, titleActions: isValid(firstScannedDate) ? (React.createElement("span", { className: styles["scanner-first-scan"] },
            "First scanned on: ",
            firstScannedDate.toLocaleString())) : undefined }, sortedScanners.map((name) => (React.createElement(Table.Row, { key: name },
        React.createElement(Table.Cell, null, name),
        React.createElement(Table.Cell, null, scanners[name].map((detection, index) => (React.createElement("div", { key: index }, detection)))))))));
};
export default ScannerList;
//# sourceMappingURL=ScannerList.js.map